<div
  class="nav-button flex items-center gap-3 px-3 py-[10px] rounded-lg cursor-pointer"
  [class.nav-button--active]="active()"
  [class.nav-button--collapsed]="collapsed()"
>
  <div class="nav-button__icon-wrap relative flex shrink-0">
    <mat-icon class="nav-button__icon">{{ icon() }}</mat-icon>
    @if (collapsed() && badge() > 0) {
      <span class="nav-button__badge nav-button__badge--dot" [matTooltip]="badgeTooltip()">
        {{ badge() }}
      </span>
    }
  </div>
  @if (!collapsed()) {
    <span class="nav-button__label whitespace-nowrap">{{ label() }}</span>
    @if (badge() > 0) {
      <span class="nav-button__badge ml-auto" [matTooltip]="badgeTooltip()">{{ badge() }}</span>
    }
  }
</div>
